// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getStyles = (): { [key: string]: any } => {
  return {
    inner: {
      height: '100%',
    },
  };
};
